import React, { useEffect, useRef, useState } from 'react';
import { getImages } from '../Common/const';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const serviceOption = [
    {
        image: 'inventory-home.webp',
        title: 'Inventory',
        url: '/cars-for-sale-boerne-tx',
    },
    {
        image: 'slide2.webp',
        title: 'Sell My Exotic',
        url: '/trade-or-sell-exotic-car',
    },
    {
        image: 'slide3-1.webp',
        title: 'Schedule Service',
        url: '/schedule-car-maintenance-or-auto-repair-boerne-tx',
    },
    {
        image: 'slide4-1.webp',
        title: 'Get Approved',
        url: '/financing',
    },
    /*{
        image: 'slide5.webp',
        title: 'Mark Customs',
        url: 'https://markcustoms.com/',
        target: 'blank'
    },*/
    {
        image: 'slide6-1.webp',
        title: 'Nationwide Delivery',
        url: '/contact-mark-motors-in-boerne-tx',
    },
    /*{
        image: 'slide7-1.webp',
        title: 'Mark Motors Detailing',
        url: 'https://markmotorsdetailing.com/',
        target: 'blank'
    },*/
    {
        image: 'slide8.webp',
        title: 'Locations',
        url: '/contact-mark-motors-in-boerne-tx',
    },
]
const isExternalUrl = (url) => /^https?:\/\//.test(url);

const Box = ({ index, isInCenter, item }) => {
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        navigate(item.url);
        window.scrollTo({ top: 0, behavior: 'instant' });
    };

    const isExternal = isExternalUrl(item.url);

    const commonClass = `service-box d-inline-block ${isInCenter ? 'selected' : ''}`;
    const content = (
        <>
            <img src={getImages(item.image)} alt='' />
            <div className='service-pos'><span>{item.title}</span></div>
        </>
    );

    return isExternal ? (
        <a
            href={item.url}
            target={item?.target === 'blank' ? '_blank' : undefined}
            rel={item?.target === 'blank' ? 'noopener noreferrer' : undefined}
            className={commonClass}
        >
            {content}
        </a>
    ) : (
        <Link
            to={item.url}
            onClick={handleClick}
            className={commonClass}
        >
            {content}
        </Link>
    );
};
const HomeServices = () => {
    const boxesRef = useRef([]);
    const [centeredBoxIndex, setCenteredBoxIndex] = useState(null);

    const checkIfInCenter = () => {
        const windowHeight = window.innerHeight;

        boxesRef.current.forEach((box, index) => {
            if (box) {
                const boxRect = box.getBoundingClientRect();
                const boxCenter = boxRect.top + boxRect.height / 2;

                // Check if the box's center is in the viewport's center
                if (boxCenter > windowHeight / 2 - 50 && boxCenter < windowHeight / 2 + 50) {
                    setCenteredBoxIndex(index);
                }
            }
        });
    };

    useEffect(() => {
        // Call on scroll
        window.addEventListener('scroll', checkIfInCenter);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', checkIfInCenter);
        };
    }, []);
    return (
        <>
            <section className='services-wrap'>
                <div className='container'>
                    <div className='row mlr-40'>
                        {serviceOption.map((item, index) => (
                            <div
                                key={index}
                                ref={(el) => (boxesRef.current[index] = el)}
                                className='col-md-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay={`${0.2 + index * 0.1}s`}
                            >
                                <Box index={index + 1} isInCenter={centeredBoxIndex === index} item={item} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* <section className='services-wrap'>
            <div className='container'>
                <div className='row mlr-40'>
                    <div ref={box1Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 0 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="0.5s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-1.png')} alt='' />
                            <div className='service-pos'><span>View Inventory</span></div>
                        </a>
                    </div>
                    <div ref={box2Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 1 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="1s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-2.png')} alt='' />
                            <div className='service-pos'><span>Sell or Trade</span></div>
                        </a>
                    </div>
                    <div ref={box3Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 2 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="1.5s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-3.png')} alt='' />
                            <div className='service-pos'><span>Service Center</span></div>
                        </a>
                    </div>
                    <div ref={box4Ref} className={`col-md-6 wow fadeInUp ${selectedBoxIndex === 3 ? 'selected' : ''}`} data-wow-duration="1s" data-wow-delay="2s">
                        <a href="#" className='service-box d-inline-block'>
                            <img src={getImages('slide-4.png')} alt='' />
                            <div className='service-pos'><span>Specials</span></div>
                        </a>
                    </div>
                </div>
            </div>
        </section> */}
        </>
    )
}

export default HomeServices